import ConstructionMaterialsSynthesisStore from "./ConstructionMaterialsSynthesis/ConstructionMaterialsSynthesisStore";
import ReceiveTreatmentStore from "./ReceiveTreatment/ReceiveTreatmentStore";
import TreamentInfoPatientStore from "./TreamentInfoDetail/TreamentInfoPatientStore";
import TreatmentTabStore from "./TreamentInfoDetail/TreatmentTab/TreatmentTabStore";
import TreatmentListStore from "./TreatmentList/TreatmentListStore";
import TreatmentListAllStore from "./TreatmentListAll/TreatmentListAllStore";
import TreatmentReportStore from "./TreatmentReport/TreatmentReportStore";
import DiagnosticReportParticipantsStore from "./TreatmentResultsDetail/DiagnosticReportParticipants/DiagnosticReportParticipantsStore";
import TreatmentReportImageResultStore from "./TreatmentResultsDetail/ReportImageResult/TreatmentReportImageResultStore";
import TreatmentAppointmentIndexStore from "./TreatmentResultsDetail/TreatmentAppointment/TreatmentAppointmentIndexStore";
import TreatmentResultsInfoDetailStore from "./TreatmentResultsInfoDetail/TreatmentResultsInfoDetailStore";
import TreatmentUpdateImageAndTourStore from "./TreatmentUpdateImageAndTour/TreatmentUpdateImageAndTourStore";
import UncompletedServicesReportStore from "./UncompletedServicesReport/UncompletedServicesReportStore";
import MedicalEquipmentUsageReportStore from "./MedicalEquipmentUsageReport/MedicalEquipmentUsageReportStore";

export const TreatmentManagementStore = {
  treatmentListStore: new TreatmentListStore(),
  receiveTreatmentStore: new ReceiveTreatmentStore(),
  treatmentReportImageResult: new TreatmentReportImageResultStore(),
  diagnosticReportParticipantsStore: new DiagnosticReportParticipantsStore(),
  uncompletedServicesReportStore: new UncompletedServicesReportStore(),
  medicalEquipmentUsageReportStore: new MedicalEquipmentUsageReportStore(),
  treatmentAppointmentIndexStore: new TreatmentAppointmentIndexStore(),
  treatmentReportStore: new TreatmentReportStore(),
  treamentInfoPatientStore: new TreamentInfoPatientStore(),
  treatmentListAllStore: new TreatmentListAllStore(),
  treatmentTabStore: new TreatmentTabStore(),
  treatmentResultsInfoDetailStore: new TreatmentResultsInfoDetailStore(),
  treatmentUpdateImageAndTourStore: new TreatmentUpdateImageAndTourStore(),
  constructionMaterialsSynthesisStore:
    new ConstructionMaterialsSynthesisStore(),
};
